module.exports = __webpack_public_path__ + "static/media/Link buttons_BS.62e38817.png";